import { useTranslation } from 'react-i18next';

import * as Yup from 'yup';

export interface LoginFormValues {
	email: string;
	password: string;
	remember: boolean;
}

const schema = (): Yup.ObjectSchema<LoginFormValues> => {
	const { t } = useTranslation();

	return Yup.object({
		email: Yup.string()
			.email(t('validationMessages.login.invalidEmail'))
			.required(t('validationMessages.mandatory')),
		password: Yup.string()
			.min(4, t('validationMessages.login.passwordMin'))
			.required(t('validationMessages.mandatory')),
		remember: Yup.boolean(),
	});
};

export default schema;
